import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { addEntities } from "../../entities";
import {
  FETCH_PURCHASES_FAILURE,
  FETCH_PURCHASES_REQUEST,
  FETCH_PURCHASES_SUCCESS
} from "../types";

const fetchPurchases = id => async (dispatch, getState, { api, schema }) => {
  try {
    dispatch(createAction(FETCH_PURCHASES_REQUEST)());
    const response = await api.factoring.getPurchases(id);
    const data = normalize(response, [schema.purchase]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_PURCHASES_SUCCESS)({
        [id]: data.result
      })
    );
    return response;
  } catch (err) {
    dispatch(createAction(FETCH_PURCHASES_FAILURE)(err));
    throw err;
  }
};

export default fetchPurchases;
